import _ from 'lodash';
import React from 'react'
import { Link } from 'react-router-dom'
import {Row,Col} from 'react-bootstrap'
import FlatButton from 'material-ui/FlatButton';
import MdDelete from 'react-icons/lib/md/delete'
import RaisedButton from 'material-ui/RaisedButton';
import MdArrowBack from 'react-icons/lib/md/arrow-back'
import MdDateRange from 'react-icons/lib/md/date-range'
import MdCloudDownload from 'react-icons/lib/md/cloud-download'
import DatePicker from 'material-ui/DatePicker';
import { connect } from 'react-redux';
import { Route, withRouter } from 'react-router-dom';
import { getJobById } from '../../../Reducers';
import * as actions from '../../../Actions/index';
import EditManual from './AdminAudioVisual';  
import Moment from 'react-moment';
import Dialog from 'material-ui/Dialog';
import LinearProgress from 'material-ui/LinearProgress';
import Header from '../../../Components/Modules/Includes/Header'

class JobDetails extends React.Component{
	constructor(props) {
	    super(props);
	    this.filterToggle = this.filterToggle.bind(this);
	    this.state = {
	    	open: false,
	    	filter: 'active-dashboard',
	    	editManual: null,
	     	showRefreshLayer: false,
	      	showJobCompletionDateLayer: false,
	      	showCustomerLayer: false,
	      	showDeleteLayer: false,
	      	showSiteLayer: false,
	      	modalIsOpen: false,
	      	modalIsOpenManual: false
	    }
	    this.selectTile = this.selectTile.bind(this);
    	this.openModalManual = this.openModalManual.bind(this);
    	this.closeModalManual = this.closeModalManual.bind(this);
	  }

  	  openModalManual() {
	    this.setState({modalIsOpenManual: true});
	  }
	  closeModalManual() {
	    this.setState({modalIsOpenManual: false});
  	  }

	  selectTile(manualType) {
	  	let urlstring = window.location;
	    let getid =urlstring.toString().split('/');
	    let jobid='';
	    if(getid[getid.length-1]){
	      jobid=getid[getid.length-1];
	    }
	    this.props.history.push(`/jobmaual/${jobid}/${manualType}`);
	  }
	  filterToggle(){
		let value =  (this.state.filter === 'active-dashboard') ? 'deactivate-dashboard' : 'active-dashboard' 
	  	this.setState({ filter : value });
	  }
      render() {
		  
      	let urlstring = window.location;
	    let getid =urlstring.toString().split('/');
	    let jobid='';
	    if(getid[getid.length-1]){
	      jobid=getid[getid.length-1];
	    }
	    let alljobs= this.props.alljobs;
	    var job;
	    var compId,companyname;
	    let companyjobs= this.props.companyjobs;
	    if(companyjobs!==null){
	    	let jobOfCompany= _.filter(companyjobs, { 'job_id': jobid});
	    	if(jobOfCompany.length!=0){
	    		compId=jobOfCompany[0].company_id;
	    		let companies=this.props.companies;
				companyname =_.filter(companies, { '_id': compId})[0].name;
	    		
	    	}
	    }
	    if(alljobs!==null){

		    job=_.filter(alljobs, { 'simpro_id': parseInt(jobid)});
		    job=job[0];
		    if(job){

			    var pdfTime,createManualAction,manuals,manualSendDate;
			    if( job.pdf_created_at ) {
			      	pdfTime=job.pdf_created_at;
			    }
			    if( job.sent_to_simpro ) {
			      	manualSendDate=job.sent_to_simpro;
			    }
			    manualSendDate
			    const manualSortOrder = [ 'ELECTRICAL', 'VOICE_DATA', 'AUDIO_VISUAL', 'OTHER_WORKS',
		      'FIRE_DETECTION', 'SECURITY', 'MECHANICAL', 'ROOFING', 'FLOORING', 'HVAC', 'RENEWABLES' ];

			    const sortedManuals = _.sortBy(_.keys(job.manuals), (m) => {
			      return _.indexOf(manualSortOrder, m);
			    });

			     manuals = _.map(sortedManuals, (manualType) => {
			      let manualTypeText='';
			      let iconClass='';
			      switch(manualType){
			      	case 'ELECTRICAL':
			      		manualTypeText='Electrical';
			      		iconClass='zmdi zmdi-input-power';
			      		break;
			      	case 'VOICE_DATA':
			      		manualTypeText='Voice Data';
			      		iconClass='zmdi zmdi-phone-in-talk';
			      		break;
			      	case 'AUDIO_VISUAL':
			      		manualTypeText='Audio Visual';
			      		iconClass='zmdi zmdi-volume-up';
			      		break;
			      	case 'OTHER_WORKS':
			      		manualTypeText='Other Works';
						  iconClass ='zmdi zmdi-case';
			      		break;
			      	case 'FIRE_DETECTION':
			      		manualTypeText='Fire Detection';
			      		iconClass='zmdi zmdi-fire';
			      		break;
			      	case 'SECURITY':
			      		manualTypeText='Security';
			      		iconClass='zmdi zmdi-shield-security';
			      		break;
			      	case 'MECHANICAL':
			      		manualTypeText='Mechanical';
			      		iconClass='zmdi zmdi-wrench';
			      		break;
			      	case 'FLOORING':
			      		manualTypeText='Flooring';
			      		iconClass='zmdi zmdi-grid';
			      		break;
			      	case 'ROOFING':
			      		manualTypeText='Roofing';
			      		iconClass='zmdi zmdi-balance';
			      		break;
			      	case 'HVAC':
			      		manualTypeText='HVAC'
			      		iconClass='zmdi zmdi-toys';
			      		break;
			      	case 'RENEWABLES':
				      	manualTypeText='Renewables'
				      	iconClass='zmdi zmdi-refresh';
				      	break;
			      	default:
			      		break;
			      }
			      const isViewed = job.manuals[manualType].isViewed;
			      return (
			      	<tr key={`manual-${manualType}`} onClick={(e) => { this.selectTile(manualType)}}>
						<td width="50%"><i className={iconClass}></i>{manualTypeText}</td>
						<td width="50%">
							<input type="checkbox" value="" checked={isViewed?true:false}  className="checkboxs" disabled="true"/>
							<span></span>
						</td>
					</tr>	
			      );
			    });
			    createManualAction = job.job_completion_date?
			        this.createManual : null;

			 
			    var completionDate = job.job_completion_date;
		    }else{
		    	return null;
		    }
	    
	    }else{
	        return null; // TODO: Return a loading indicator
	    }
	    const action = [
          <FlatButton
            label="Cancel"
            primary={true}
            onClick={this.closeModal}
          />,
          <RaisedButton
            label="Yes"
            primary={true}
            labelStyle={{'color': '#fff'}}
            keyboardFocused={true}
            onClick={this.deleteJob}
          />
        ];
        return(<div>
        			<Header />
          		   <div className="dashboard-page">
                    <div className={`right-content-dashboard ${this.state.filter}`}>
	                   	<div className="dashboard-content-sec table-dashboard audio-visual-content">
	                   		<div className="top-heading">
								<div className="back-button-heading">
									<h2><Link to={`/admin-company/${compId}`}><MdArrowBack /></Link>{companyname} - Job #{jobid}</h2>
								</div>
								<div className="right-job-id" download>
									{ job && job.pdf_download_url ?
										<RaisedButton 
	                                   		label="Download Job Manual" 
	                                   		type="submit"
	                                   		icon={<MdCloudDownload fontSize="18px" />}
	                                   		labelColor="#fff" 
	                                   		 labelStyle={{'fontWeight': '500' }}
	                                   		fullWidth={false} 
	                                   		href={job?job.pdf_download_url:''}
	                                   		target='_blank'
	                                   	/>
	                                   	: null }
								</div>
							</div>
	                   		<div className="dashboard-table-data">
	                   			<div className="audio-visual-list">
	                   				<h3>General</h3>
	                   				<table className="dashboard-table">
	                   					<thead>
	                   						<tr>
	                   							<th width="50%">Status </th>
	                   							<th width="50%">{job.simpro_job.Status.StatusName}</th>
	                   						</tr>
	                   						<tr>
	                   							<th width="50%">Imported at </th>
	                   							<th width="50%">
									            	<Moment format=" MMM DD YYYY , hh:mm a">
										                {job.imported_at}
										            </Moment>
	                   							</th>
	                   						</tr>
	                   						<tr>
	                   							<th width="50%">Job Manual PDF created at </th>
	                   							<th width="50%">
	                   								{pdfTime?
										            <Moment format=" MMM DD YYYY , hh:mm a">
										                {pdfTime}
										            </Moment>
										            : 'Not Created'
										        	}

									            </th>
	                   						</tr>
	                   						<tr>
	                   							<th width="50%">Sent to simPRO </th>
	                   							<th width="50%">
	                   								{manualSendDate?
										            <Moment format=" MMM-DD-YYYY , hh:mm a">
										                {manualSendDate}
										            </Moment>
										            : 'Not Uploaded'
										        	}

									            </th>
	                   						</tr>
	                   						<tr>
	                   							<th width="50%">Customer </th>
	                   							<th width="50%">{job.simpro_job.Customer.CompanyName}</th>
	                   						</tr>
	                   						<tr>
	                   							<th width="50%">Site </th>
	                   							<th width="50%">{job.simpro_job.Site.SiteName}</th>
	                   						</tr>
	                   						<tr>
	                   							<th width="50%">Job Completion Date  </th>
	                   							<th width="50%">
	                   								{completionDate?
	                   								<Moment format=" MMM DD YYYY ">
										                {completionDate}
										            </Moment>
										            : '-' }
										           </th>
	                   						</tr>
	                   					</thead>
	                   				</table>
	                   			</div>
	                   		</div>
	                   		<div className="dashboard-table-data margb20px">
	                   			<div className="audio-visual-list">
	                   				<h3>Manuals</h3>
	                   				<table className="dashboard-table manual-list">
	                   					<thead>
	                   						<tr>
	                   							<th width="50%">Manual   
	                   								<div className="manual-info">
														<i className="zmdi zmdi-info"></i>
														<div className="information">
															<p>Click the template name to edit information from simPRO</p>
														</div>
													</div>
	                   							</th>
	                   							<th width="50%">Approved?</th>
	                   						</tr>
	                   					</thead>
	                   					<tbody>
	                   						{manuals}                						
	                   					</tbody>
	                   				</table>
	                   			</div>
	                   		</div>
	                   	</div>
                   	 </div>
                   	 </div>
                  </div>
            )
    }
} 
const mapStateToProps= (state,props)=> {
    return {
      companydetails: state.login.companydetail,
      subsusers: state.login.subsuser,
      subscriptions: state.login.subscriptions,
      alljobs: state.login.alljobs,
      companyjobs: state.login.companyjobs,
      templates: state.templates,
      companies: state.login.company,
    };
}

JobDetails = withRouter(connect(
  mapStateToProps,
  actions
)(JobDetails));

export default JobDetails;


// WEBPACK FOOTER //
// ./src/Components/Pages/Admin/AdminJobDetail.js